export default function ContactInfoItem({ item, ActionIcon, index = 0 }) {
  const { label, value, href, action, Icon } = item;

  const safeHref = href || "#";
  const isExternal = safeHref.startsWith("http");

  const SafeIcon = Icon || (() => null);
  const SafeActionIcon = ActionIcon || (() => null);

  return (
    <div
      className={`contact-card__item reveal-on-scroll reveal-on-scroll--up reveal-delay-${
        (index % 4) + 1
      }`}
    >
      <div className="contact-card__item-icon">
        <SafeIcon />
      </div>

      <div className="contact-card__item-content">
        <span>{label}</span>
        <strong>{value}</strong>
      </div>

      {href ? (
        <a
          href={safeHref}
          target={isExternal ? "_blank" : undefined}
          rel={isExternal ? "noreferrer" : undefined}
          className="contact-card__item-action"
        >
          {action || "Ver"}
          <SafeActionIcon />
        </a>
      ) : (
        <span className="contact-card__item-action is-disabled">
          {action || "Indisponível"}
          <SafeActionIcon />
        </span>
      )}
    </div>
  );
}